import {Button, ButtonSize, ButtonStyle} from '@mintdata-wsp/common/components/button/Button';
import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {ConnectDomainState} from '@mintdata-wsp/common/state/ui/publish/PublishState';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {Spinner, SpinnerSize, SpinnerStyle} from '@mintdata-wsp/common/components/spinner/Spinner';
import {BaseComponentWithContext} from '@mintdata/mint-kit/api/components/BaseComponentWithContext';
import {observer} from 'mobx-react';
import * as React from 'react';
import {WindowLocationUtil} from '@mintdata-wsp/common/util/WindowLocationUtil';

const styles = require('@mintdata-wsp/wsp/ui/dialogs/publish/ConnectDomainSecondStep.less');

export interface IConnectDomainSecondStepProps
{
}

@observer
export class ConnectDomainSecondStep extends BaseComponentWithContext<IConnectDomainSecondStepProps>
{
    public render():JSX.Element
    {
        const {cnameHostname, connectDomainState, cnameCheckId} = rootState.ui.publish;

        return <Column>
            <div className={styles.addCNameNote}>
                Add this <b>CNAME record</b> to your DNS provider
            </div>
            <div className={styles.cnameTable}>
                <div className={styles.header}>
                    <div className={styles.typeColumn}>
                        Type
                    </div>
                    <div>
                        Host
                    </div>
                    <div>
                        Value
                    </div>
                    <div className={styles.actionColumn} />
                </div>
                <div className={styles.body}>
                    <div>
                        CNAME
                    </div>
                    <div>
                        {cnameHostname}
                    </div>
                    <div>
                        {WindowLocationUtil.getRootDomain()}
                    </div>
                    <div>
                        <Button
                            style={ButtonStyle.SimpleSecondary}
                            size={ButtonSize.Small}
                            icon={MDIcons.common.ContentCopy}
                            iconSize={MDIconSize.medium}
                            iconClassName={styles.copyIcon}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.statusRow}>
                {connectDomainState === ConnectDomainState.Checking && <Row>
                    <Spinner
                        size={SpinnerSize.Medium_24}
                        style={SpinnerStyle.Blue}
                        className={styles.checkingSpinner}
                    />
                    <div className={styles.checkingMessage}>Checking your DNS settings...</div>
                </Row>}
                {connectDomainState === ConnectDomainState.Failure && <Row>
                    <MDIcon
                        name={MDIcons.common.Info}
                        size={MDIconSize.medium20}
                        className={styles.errorIcon}
                    />
                    <Column className={styles.errorMessage}>
                        <div>Could not verify your domain.</div>
                        <div>
                            {
                                cnameCheckId
                                    ? 'There was an issue with setting up your domain. Please contact us for support.'
                                    : 'Please check your DNS settings and try again.'
                            }
                        </div>
                    </Column>
                </Row>}
            </div>
        </Column>;
    }
}
